import React from "react";

const inputClass =
  "w-full px-4 py-2.5 text-sm rounded-lg border border-gray-300 outline-none focus:ring-2 focus:ring-[#F3BC48] font-manrope bg-white";

/**
 * The class's own registration questions, asked once for each child being
 * registered: a jersey name or a shirt size belongs to the child, not to the
 * order.
 */
const ClassQuestionsFields = ({
  questions,
  children,
  answersByChild,
  onChange,
}) => {
  if (!questions?.length || !children?.length) return null;

  return (
    <div className="bg-white/50 backdrop-blur-sm rounded-fluid-xl p-fluid-5 shadow-sm border border-white/20 space-y-5">
      <div>
        <h3 className="text-sm font-semibold font-manrope text-[#173151]">
          A few questions for this class
        </h3>
        <p className="text-xs text-[#666D80] mt-1 font-manrope">
          Questions marked * must be answered.
        </p>
      </div>

      {children.map((child) => {
        const answers = answersByChild?.[child.id] || {};
        return (
          <div key={child.id} className="space-y-3">
            {children.length > 1 && (
              <p className="text-sm font-semibold font-manrope text-[#173151]">
                {child.first_name}
              </p>
            )}
            {questions.map((q) => {
              const fieldId = `class-question-${child.id}-${q.id}`;
              const value = answers[q.id] || "";
              const change = (e) => onChange(child.id, q.id, e.target.value);
              return (
                <div key={q.id}>
                  <label
                    htmlFor={fieldId}
                    className="block text-sm font-medium font-manrope text-[#173151] mb-1"
                  >
                    <span className="sr-only">{child.first_name}: </span>
                    {q.label}
                    {q.required && <span className="text-red-600"> *</span>}
                  </label>
                  {q.type === "select" ? (
                    <select
                      id={fieldId}
                      value={value}
                      onChange={change}
                      required={Boolean(q.required)}
                      className={inputClass}
                    >
                      <option value="">Select…</option>
                      {(q.options || []).map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      id={fieldId}
                      type="text"
                      value={value}
                      onChange={change}
                      required={Boolean(q.required)}
                      maxLength={500}
                      className={inputClass}
                    />
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ClassQuestionsFields;
